import { defineFcm } from '../shared/factory';

export const FCM_PETITION_SIGN_FORM_SINGLE_ADDRESS_FIELD = defineFcm('petition_sign_form_single_address_field')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Sign Form',
		description:
			'Enables the logic to collect single address field information from users when signing a petition: https://change.atlassian.net/browse/CHANGE-85492',
		import: false,
		deprecated: 'FCM no longer in use — safe to delete after 2026-04-28',
	});
